import React from 'react'

/**
 * Reusable upload progress bar component
 */
const UploadProgressBar = ({ progress, className = '' }) => {
  return (
    <div style={{ width: '100%', marginTop: '16px' }} className={className}>
      <div
        style={{
          width: '100%',
          height: '8px',
          background: '#FFF',
          borderRadius: '50px',
        }}>
        <div
          style={{
            width: `${progress}%`,
            height: '100%',
            background: '#EFC030',
            transition: 'width 0.2s',
          }}
        />
      </div>
    </div>
  )
}

export default UploadProgressBar
